import React from "react"
import styles from "./Footer.module.css"

export type FooterLink = {
    label: string
    href: string
}

type FooterProps = {
    /** コピーライト文言を丸ごと差し替えたいとき（未指定なら foodslabo のデフォルト） */
    copyright?: string
    /** ナビリンク（未指定なら foodslabo のデフォルト） */
    links?: FooterLink[]
    className?: string
}

const defaultLinks: FooterLink[] = [
    { label: "プライバシーポリシー", href: "https://cuolega.co.jp/privacy" },
    { label: "利用規約", href: "https://cuolega.co.jp/terms" },
    { label: "会社概要", href: "https://cuolega.co.jp/profile/" },
    { label: "お問い合わせ", href: "https://forms.gle/vvaU9X7n3mrUapsM6" },
]

export default function Footer({
    copyright,
    links = defaultLinks,
    className,
}: FooterProps) {
    const year = new Date().getFullYear()
    const copyrightText =
        copyright ??
        `Copyright © 2022-${year} foodslabo by cuolega All rights reserved.`

    const handleScrollTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" })
    }

    return (
        <footer className={`${styles.footer} ${className ?? ""}`}>
            <button
                type="button"
                className={styles.pagetop}
                onClick={handleScrollTop}
                aria-label="ページ上部へ戻る"
            >
                <svg
                    className={styles.pagetopIcon}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                >
                    <path
                        d="M4.99986 15C4.74398 15 4.48797 14.9023 4.29297 14.707C3.90234 14.3164 3.90234 13.6836 4.29297 13.2929L9.58741 7.99992L4.29297 2.70705C3.90234 2.31642 3.90234 1.6836 4.29297 1.29297C4.6836 0.902343 5.31642 0.902343 5.70705 1.29297L11.7071 7.29304C12.0977 7.68367 12.0977 8.31649 11.7071 8.70712L5.70705 14.7072C5.51236 14.9031 5.25611 15 4.99986 15Z"
                        fill="#444444"
                        stroke="#444444"
                        strokeLinejoin="round"
                    />
                </svg>
                <span className={styles.pagetopText}>TOPへ</span>
            </button>

            <small className={styles.copyright}>{copyrightText}</small>

            <nav className={styles.nav}>
                <ul className={styles.navList}>
                    {links.map(link => (
                        <li key={link.href} className={styles.navItem}>
                            <a href={link.href} className={styles.navLink}>
                                {link.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </nav>
        </footer>
    )
}
